import Vue from 'vue'
Vue.filter('KB', bytesNumber => {
  const sizeInKb = Math.ceil(bytesNumber / 1024)

  return `${sizeInKb} Kb`
})
